let accordions = document.querySelectorAll(".component-faqs__accordion-trigger");

if (accordions !== null && accordions !== undefined) {
    accordions.forEach(function(accordion){
        accordion.addEventListener("click", function () {
            let container = this.closest('.component-faqs__accordion-container');
            container.classList.toggle('active');
        });
    });
}